import stylesheet from './index.css?url';
import { buildLinks } from '@ui/documentShell.jsx';

// The document shell, the pageview hook, the hydrate fallback and the error
// boundary are shared with every other frontend module - see
// @ui/documentShell.jsx. Only the two things that legitimately differ per
// module live here: this module's own stylesheet, and its default metadata.
export { Layout, HydrateFallback, App as default, ErrorBoundary } from '@ui/documentShell.jsx';

export function links() {
  return buildLinks(stylesheet);
}

// The default for any page that does not override it. Every public page
// here SHOULD override it - a shared title across indexed pages is a
// duplicate-content signal, and routes/help.jsx et al. already set their own
// from the Markdown front matter.
export function meta() {
  return [
    { title: 'WriteUp' },
    {
      name: 'description',
      content:
        'Your handwriting expert for the workshop - turn scanned repair orders into clean tech write-ups and plain-language customer summaries in seconds.'
    }
  ];
}
